import { ModalManager } from "./ModalManager/ModalManager";
import { ModalProvider as CoreModalProvider } from "../../react-components-core";
import { ReactNode } from "react";

interface ModalProviderProps {
    children?: ReactNode;
}

export default function ModalProvider({ children }: ModalProviderProps): JSX.Element {
    return (
        <CoreModalProvider>
            <ModalManager />
            {children}
        </CoreModalProvider>
    );
}
